import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import OutletFlashSale from "./OutletFlashSale";

export const InitModal = ({ isOpen, renderElement, stateFromHeader, isClosable = true }) => {
  if (isOpen) {
    ReactDOM.unmountComponentAtNode(renderElement);
    return null;
  }

  ReactDOM.render(
    <Router>
      <Route path="/" component={() => <OutletFlashSale isClosable={isClosable} stateFromHeader={stateFromHeader} />} />
    </Router>,
    renderElement
  );
};
